import { Col, Row, Form } from 'antd';
import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { authFeatureConstants, COMMON_ERROR, GUTTOR_SPACE, PATH_URLS, validIds } from '../../../../shared/constants/commonConstants';
import { fetchClaimDetails, fetchClaimDetailsPayerType, setClaimData, setTimeLineColorCode } from '../../../../store/actions/claimDetailsAction';
import CustomFormStepper from '../newAdmission/panels/CustomFormStepper/CustomFormStepper';
import { base64UrlDecode, base64UrlEncode, canActivate, centeredNotification } from '../../../../utils/utility';
import { fetchLookUpValues } from '../../../../store/actions/lookUpAction';
import { setIsClaimDetailApiLoaded, setIsEasyDischargeCase, setPayerNotConfig } from '../../../../store/actions/inPatientAction';
import {
  clearNewAdmissionState, setAdmissionFormType, setIsShowAdmissionForm, setUploadedFiles, updatePackageSelection,
  updateSelectedCenter,
} from '../../../../store/actions/newAdmissionAction';
import {
  getAdmissionFormType, getIsPageNameEdit, getIsPageNameEditDischarge,
  getIsPageNameReconsider, getPreviousUrl, reArrangeOptions, allowGetPatientSearch, findSelectedPayer,
} from '../service/crmUtils';
import DetailTimeline from '../newAdmission/panels/cards/DetailTimeline/DetailTimeline';
import { RootState } from '../../../../store';
import PageHeader from '../../../../shared/components/pageHeader/PageHeader';
import { useHistory } from 'react-router-dom';
import FileUploadMinimize from '../../../../shared/components/fileUpload/FileUploadMinimize';
import BuddhiMedFileUpload from '../../../../shared/components/fileUpload/buddhimedFileUploadModal/BuddhiMedFileUploadModal';
import { useMigrateClaimDetail } from '../../../../shared/hooks/useMigrateClaimDetail';
import { RightActionsClaimDetailHeader } from './RightActionsClaimDetailHeader';
import { changePayer, setAllPayers } from '../../../../store/actions/payerListAction';
import { NewAdmissionState } from '../../../../store/models/newAdmissionModel';
import { ADMISSION_FORM_TYPES, AUTOMATION_CANCELLED_INFO, DETAIL_NAV, NEW_DETAIL_NAV, NOTIFICATION_TYPE } from '../../../../shared/constants/crmConstants';
import MultipayerFormWrapper from '../newAdmission/panels/multipayerFormWrapper/multiPayerFormWrapper';
import useSetDefaultPayer from '../../../../shared/hooks/useSetDefaultPayer';
import ApplicationDetail from '../../../../shared/services/applicationDetail.service';
import { getHospDetail, setDeeplinkDto, setUserAuthData } from '../../../../store/actions/authAction';
import {decryptText} from '../../../../utils/encryptDecrypt';
import ConsentModal from '../newAdmission/panels/ConsentModal/ConsentModal';
import { getPatientVisitDetails, setAutomatedNewAdmission, setHISDoctorList, setPatientSearchDetail } from '../../../../store/actions/hospitalAction';
import { ApplicationDetailModel } from '../../../../store/models/applicationDetailModel';
import { isEmpty } from 'lodash';
import { DeeplinkDto } from '../../../../store/models/authModel';
import AutomationLoaderModal from '../../../../shared/components/modal/NAAutomationLoaderModal/AutomationLoaderModal';
import { Payer } from '../../../../shared/models/payer.model';

const Detail = ({ match, location: { pathname } }: any): ReactElement => {
  const mounted = useRef(false);
  const dispatch = useDispatch();

  const [isCancelEnabled, setIsCancelEnabled] = useState(false as any);
  const [selectedTab, setSelectedTab] = useState(-1);
  const [isLookUpLoading, setIsLookUpLoading] = useState(false);
  const [isDetailLoading, setIsDetailLoading] = useState(false);
  const [originalClaimDetail, setOriginalClaimDetail] = useState({});
  const appDetailService = ApplicationDetail.instance;
  const groupProviders = appDetailService.getGroupProviders();
  const { isDraftBtnClicked } = useSelector((state: RootState): any => state.selectedInPatientDetail);
  const appdetails = useSelector(
    (state: RootState): ApplicationDetailModel => state.applicationDetail,
  );
  const { hisid, hisProviderID} = appdetails?._applicationDetail?.hospitalDetail?.providerConfigurableProperties;
  const loggedInUserId = appdetails?._applicationDetail?.userDetail?.userId;
  const isHISSearchEnabled = ApplicationDetail?.instance?.getIsHISSearchEnabled();
  const isEdit = getIsPageNameEdit(pathname);
  const isEditDischarge = getIsPageNameEditDischarge(pathname);
  const isEditReconsider = getIsPageNameReconsider(pathname);
  const editPage = isEdit || isEditDischarge || isEditReconsider;

  useMigrateClaimDetail(isDetailLoading, isLookUpLoading, originalClaimDetail);
  const setDefaultPayer = useSetDefaultPayer();
  const history = useHistory();
  const [buddhimedForm] = Form.useForm();
  const[aForm] = Form.useForm();
  const {
    claimDetails,
    reloadCurrentPage,
    isCancelledClaim,
  } = useSelector((state: RootState): any => state.admissionDetails);
  const allPayers: any[] = useSelector((state: RootState): any => state.payerList.allPayers || []);
  const { admissionFormType, toggleClick, settlementModal, draftValue } = useSelector((state: RootState):
   NewAdmissionState => state?.newAdmission || {});
  const { patientName } = claimDetails;
  const {hospitalSearchPatientDetails} = useSelector((state: RootState): any => state.hospital);
  const claimDetailResponse = JSON?.parse(localStorage?.getItem('claimDetailResponse') || '{}');
  const { deeplinkDto } = useSelector((state: RootState): any => state.auth);
  const [isDeeplinkProcessed, setIsDeeplinkProcessed] = useState(false);

  const lookUpSuccessCallback = (): void => {
    if (mounted.current) {
      setIsLookUpLoading(false);
      setIsDeeplinkProcessed(true);
    }
  };

  const setupConfiguredPayer = (selectedPayer: Payer, uniquePayerId: string): void => {
    setIsLookUpLoading(true);
    dispatch(changePayer(selectedPayer));
    const formType = getAdmissionFormType(selectedPayer);
    dispatch(setAdmissionFormType(formType));
    const selectedUniquePayerId = !canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS) && uniquePayerId;
    dispatch(fetchLookUpValues(lookUpSuccessCallback, selectedUniquePayerId));
  };

  const updateRedirectUrlWithClaimData = (claimDetail: any): void => {
    let updatedDetailsurl = pathname;
    const isCancel = false;
    const { payerClaimNo, payerId, productCode, hospActionId, providerId } = claimDetail;
    const uniquePayerId = `${payerId}${productCode || ''}`;
    const selectedPayer = findSelectedPayer(allPayers, uniquePayerId);
    if (selectedPayer) {
      dispatch(setPayerNotConfig(false));
    }
    updatedDetailsurl = PATH_URLS.INPATIENT_ROOT + PATH_URLS.CLAIM_DETAIL +
      `/${base64UrlEncode(`${base64UrlEncode(payerClaimNo)}/${hospActionId}/${payerId}/${uniquePayerId}/${productCode}/${isCancel}/${providerId}`)}`;
    history.replace(updatedDetailsurl);
    setIsDetailLoading(false);
    setupConfiguredPayer(selectedPayer, uniquePayerId);
  };

  const successCallback = (claimDetail: any): void => {
    if (mounted.current) {
      const { colorCode } = claimDetail;
      dispatch(setTimeLineColorCode(colorCode));
      setOriginalClaimDetail(claimDetail);
      dispatch(fetchClaimDetailsPayerType(claimDetail?.payerType));
      setIsDetailLoading(false);
      if ((!isHISSearchEnabled) || (!claimDetail?.isHISClaim)) {
        dispatch(setIsClaimDetailApiLoaded(true)); // to handle multiple re-renders in case of his
      }
    }
    if (isHISSearchEnabled && claimDetail?.allowStatus?.some((status: any): boolean => validIds.includes(status?.id))) {
      const allowPatientSearch = allowGetPatientSearch(claimDetail, loggedInUserId, hisid, hisProviderID);
      if (allowPatientSearch?.isAllowed) {
        const updatedHISPayload = allowPatientSearch?.payload;
        // fetch patient details from HIS
        dispatch(getPatientVisitDetails(updatedHISPayload, (): void => {}, (): void => {}));
        dispatch(setIsClaimDetailApiLoaded(true));
      }
    }
    if (!isEmpty(deeplinkDto)) {
      updateRedirectUrlWithClaimData(claimDetail);
    }
  };

  const handleCancelAutomation = (): void => {
    dispatch(setAutomatedNewAdmission(false));
    centeredNotification(AUTOMATION_CANCELLED_INFO, NOTIFICATION_TYPE.INFO);
    dispatch(setDeeplinkDto({} as DeeplinkDto));
    dispatch(setIsClaimDetailApiLoaded(true));
  };

  // PreFill bill details from HIS
  useEffect((): void => {
    if (editPage) {
      !isEmpty(hospitalSearchPatientDetails?.[0]) && dispatch(setPatientSearchDetail(hospitalSearchPatientDetails[0]));
    } else {
      dispatch(setPatientSearchDetail([]));
    }
  }, [hospitalSearchPatientDetails]);

  useEffect((): any => {
    mounted.current = true;
    return (): boolean => {
      dispatch(setClaimData({}));
      dispatch(setUploadedFiles([]));
      dispatch(updatePackageSelection([]));
      dispatch(clearNewAdmissionState());
      dispatch(setHISDoctorList([]));
      setDefaultPayer();
      if (canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS)) {
        const providerDetailString: any = decryptText(localStorage.getItem('providerDetail') || '{}');
        const providerDetail = JSON.parse(providerDetailString);
        dispatch(setUserAuthData(providerDetail));
      }

      return mounted.current = false;
    };
  }, []);

  const handleClaimDetailFailure = (): void => {
    history.push('/claims/in-patient');
    centeredNotification(COMMON_ERROR);
    dispatch(setClaimData({}));
  };

  const failedCallback = (): void => {
    if (mounted.current) {
      handleClaimDetailFailure();
      dispatch(setAutomatedNewAdmission(false));
      dispatch(setDeeplinkDto({} as DeeplinkDto));
    }
  };

  useEffect((): any => {
    dispatch(setIsEasyDischargeCase(false));

  }, []);

  useEffect((): any => {
    // handled cancel case
    if (isCancelledClaim) {
      dispatch(setClaimData({}));
    }
  }, [isCancelledClaim]);

  useEffect((): any => {
    dispatch(setIsShowAdmissionForm(true));
    const { params: { claimDetail } } = match;
    const splittedDetail = base64UrlDecode(claimDetail).split('/');
    const providerId = splittedDetail.length > 6 ? splittedDetail[6] : splittedDetail[5];
    const hospId = [];
    hospId?.push(Number(providerId));
    if (canActivate(authFeatureConstants.NEW_ADMISSION_BEHALF_OF_HOSPITALS)) {
      const reArrangeCenterOptions =
        reArrangeOptions(
          groupProviders,
          'providerId',
          'providerName',
          {isRestRequired: true},
        );
      const filteredSelectedCenter = (reArrangeCenterOptions || [])?.filter((co: any): any => co?.key === providerId);
      dispatch(updateSelectedCenter(filteredSelectedCenter?.[0] || {}));
      dispatch(getHospDetail(hospId, getHospSuccess, getHospFailure));
    } else {
      getClaimDetails(allPayers);
    }
  }, [reloadCurrentPage, isCancelledClaim]);

  const getHospSuccess = (result: any): any => {
    result.rohiniCode = result.providerRohiniCode;
    dispatch(setUserAuthData(result));
    const { configuredPayers } = result;
    dispatch(setAllPayers(configuredPayers));
    getClaimDetails(configuredPayers);
  };

  const getHospFailure = (errMsg: string): any => {
    centeredNotification(errMsg);
  };

  const getClaimDetails = (configuredPayersList: any): void => {
    dispatch(setIsShowAdmissionForm(true));
    const { params: { claimDetail } } = match;
    const splittedDetail = base64UrlDecode(claimDetail).split('/');
    const [claimNoEncrypted, actionId, payerId, uniquePayerId, tempProductCode, isCancel] = splittedDetail;
    const tempClaimNo = base64UrlDecode(claimNoEncrypted);
    const claimNo = (!tempClaimNo || tempClaimNo === 'null' || tempClaimNo === 'undefined') ? undefined : tempClaimNo;
    const productCode = (!tempProductCode || tempProductCode === 'null' || tempProductCode === 'undefined') ? undefined : tempProductCode;
    setIsCancelEnabled(isCancel);
    const selectedPayer = findSelectedPayer(configuredPayersList, uniquePayerId);
    const isPayerConfigured = !!selectedPayer;
    dispatch(setPayerNotConfig(!isPayerConfigured));
    setIsDetailLoading(true);
    // Handle claim details fetching or processing
    if (isEmpty(claimDetails)) {
      dispatch(fetchClaimDetails({
        claimNo,
        actionId: parseInt(actionId, 10),
        payerId: parseInt(payerId, 10),
        productCode,
        successCallback,
        failedCallback,
      }));
    } else {
      if (!isEmpty(claimDetailResponse)) {
        setOriginalClaimDetail(claimDetailResponse);
        dispatch(fetchClaimDetailsPayerType(claimDetailResponse?.payerType));
        setIsDetailLoading(false);
      } else {
        handleClaimDetailFailure();
        return;
      }
    }
    if (isPayerConfigured) {
      setupConfiguredPayer(selectedPayer, uniquePayerId);
    }
  };

  const getAdmissionForm = (): ReactElement | null => {
    if (admissionFormType === ADMISSION_FORM_TYPES.NORMAL) {
      return (
        <CustomFormStepper
          detailNav={appDetailService.getIsNewAutomationEnabled() ? NEW_DETAIL_NAV() : DETAIL_NAV()}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
          isLoading={isLookUpLoading || isDetailLoading}
          form={aForm}
          className="normal-detail-panel-height"
        />
      );
    }
    if (admissionFormType === ADMISSION_FORM_TYPES.MULTIPAYER || admissionFormType === ADMISSION_FORM_TYPES.CORPORATE) {
      return (
        <MultipayerFormWrapper
          form={aForm}
          className="multipayer-detail-panel-height"
        />
      );
    }
    return null;
  };

  return (
    <React.Fragment>
      {draftValue === 'settlement' || isDraftBtnClicked ?
        <PageHeader pageTitle={patientName || 'Member'}
          backUrl={getPreviousUrl(pathname)}
        /> :
        <PageHeader pageTitle={patientName || 'Member'}
          backUrl={getPreviousUrl(pathname)}
          rightComponent={RightActionsClaimDetailHeader}
          isCancelEnabled={isCancelEnabled}
          form={aForm}
          isDeeplinkProcessed={isDeeplinkProcessed}
        />
      }
      <div className="ant-tabs-content-holder tab-custom-container pb-0">
        <Row gutter={GUTTOR_SPACE}>
          <Col md={16}>
            {getAdmissionForm()}
          </Col>
          <Col md={8}>
            <FileUploadMinimize />
            <DetailTimeline />
          </Col>
        </Row>
      </div>
      {isDraftBtnClicked && settlementModal ?
        <BuddhiMedFileUpload isLoading={false} form={buddhimedForm} /> :
        !isDraftBtnClicked && <BuddhiMedFileUpload isLoading={false} form={buddhimedForm} />}
      {toggleClick &&
        <ConsentModal />
      }
      <AutomationLoaderModal isClaimDetailPage={true} onCancel={handleCancelAutomation} />
    </React.Fragment>
  );
};

export default Detail;
